import { d as e } from "./descriptors.js";
import { f as r } from "./fails.js";
import { d as t } from "./document-create-element.js";
var o = !e && !r(function () {
  return 7 != Object.defineProperty(t("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
});
export { o as i };